<template>
  <div class="wrapper w-100 flex-center premium-page-wrapper">
    <div class="premium-page">
      <div class="row flex-v-center">
        <div class="col-md-6">
          <img src="../assets/img/no-premium-image.png" alt="image" class="mr-3 mobile-hidden">
        </div>
        <div class="col-md-6">
          <div class="ml-3 ml-0-xs">
            <div class="text-center-xs">
              <img alt="logo" src="./../assets/img/logo-new.svg" class="logo mb-2">
            </div>
            <p class="text-bold text-center-xs text-lg mb-2">{{$lang.messages.remote_access.description}}</p>
            <div class="text-center-xs mb-3">
              <button class="btn btn-premium" @click="showGetPremium = true">{{$lang.messages.remote_access.try_free_trial}}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center mt-3" v-if="user && !accountData.isPremium">
        <div class="header-text text-bold mb-05">{{ user.email }}</div>
        <div><a href="#" class="btn btn-secondary" @click.prevent="out">{{$lang.messages.sign_out}}</a></div>
      </div>
      <div v-else>
        <button class="btn btn-main w-100" @click="$router.push('/login')">{{$lang.messages.remote_access.already_have_premium}}</button>
      </div>
    </div>
    <GetPremiumModal v-if="showGetPremium"
                     :customer="accountData.customer"
                     v-on:closepremiummodal="onCloseModal"
                     v-on:premiumispurchased="onPurchasePremium"
                     v-on:updatesettings="saveAccountSettings"/>
    <PremiumPurchasedModal
        v-show="showPremiumIsPurchased"
        v-on:closemodal="premiumIsPurchased"/>
  </div>
</template>
<script>
import {mapState} from "vuex";
import saveSetting from "@/components/mixins/saveSetting";
import GetPremiumModal from "@/components/GetPremiumModal";
import PremiumPurchasedModal from "@/components/PremiumPurchasedModal";
import firebase from "firebase/app";
import {reportEvent} from "@/helpers/utils";
import {extensionLink} from "@/helpers/configs";

export default {
  name: 'PremiumNoLogin',
  mixins: [saveSetting],
  data: function (){
    return {
      showGetPremium: this.$route.query.openPremiumModal || this.$route.query.needext || false,
      showPremiumIsPurchased: false,
      redirectToExtension: this.$route.query.needext
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      accountData: state => state.accountData,
    })
  },
  methods: {
    getPremium () {
      this.$router.push('/login')
    },
    premiumIsPurchased () {
      this.showPremiumIsPurchased = false;
      if (this.$route.query.openPremiumModal) {
        this.$router.push('/addDevice');
      } else {
        this.$router.push('/dashboard');
      }
    },
    out() {
      firebase.auth().signOut();
      reportEvent('userSignOut');
    },
    onCloseModal(){
      this.redirectToExtension ? window.location.assign(extensionLink) : this.$router.back()
    },
    onPurchasePremium(){
      this.redirectToExtension ? window.location.assign(extensionLink) : this.showPremiumIsPurchased = true
    }
  },
  components: {
    GetPremiumModal, PremiumPurchasedModal
  },
}
</script>

<style lang="scss">
  @import "../assets/styles/base.module";

  .premium-page {
    max-width: 1200px;
    margin: 0 auto;
    padding: 30px;

    .content-block {
      height: auto;
    }

    &-wrapper {
      background: linear-gradient(0deg, #F5F7FB, #F5F7FB), #F5F7FB;
    }
  }
</style>
